const STANDALONE_DISPLAY_MODES = ["standalone", "fullscreen", "minimal-ui"] as const;

const displayModeQuery = (mode: string): string => `(display-mode: ${mode})`;

const matchesStandaloneMode = (): boolean =>
	STANDALONE_DISPLAY_MODES.some((mode) => window.matchMedia?.(displayModeQuery(mode))?.matches === true);

// iOS Safari exposes standalone launch via this non-standard navigator flag.
const hasIosStandaloneFlag = (): boolean =>
	(window.navigator as Navigator & { standalone?: boolean }).standalone === true;

const isStandaloneDisplay = (): boolean => {
	if (typeof window === "undefined") return false;
	return matchesStandaloneMode() || hasIosStandaloneFlag();
};

export const subscribeStandaloneDisplay = (onChange: () => void): (() => void) => {
	if (typeof window === "undefined" || !window.matchMedia) return () => {};
	const lists = STANDALONE_DISPLAY_MODES.map((mode) => window.matchMedia(displayModeQuery(mode)));
	for (const list of lists) list.addEventListener?.("change", onChange);
	return () => {
		for (const list of lists) list.removeEventListener?.("change", onChange);
	};
};

export default isStandaloneDisplay;
